import {
  Breadcrumb,
  Button,
  Card,
  DatePicker,
  Divider,
  Empty,
  Form,
  Modal,
  Radio,
  Select,
  Tabs,
  Tooltip,
} from "antd";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import AccountService from "../../../../services/accounts.service";
import moment from "moment";
import { AiOutlineLeft } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import {
  depositAccountListSelector,
  profileDetailsSelector,
} from "../../../../store/selectors/app.selector";
import { ReactComponent as HomeIcon } from "../../../../assests/images/home-line.svg";
import SetStatementRemarks from "../statement-remarks";
import { ReactComponent as TitleIcon } from "../../../../assests/images/accountBread.svg";
import { useTranslation } from "react-i18next";
import DepositStatementGrid from "./deposit-statement-grid";
import DepositStatementList from "./depositstatement-list";
import { setSelectedAccount } from "../../../../store/actions/app.action";
const remarksBill = require("../../../../assests/icons/d_bill.png");
const remarksBusiness = require("../../../../assests/icons/d_business.png");
const remarksEntertainment = require("../../../../assests/icons/d_entertainment.png");
const remarksfood = require("../../../../assests/icons/d_food.png");
const remarksHelth = require("../../../../assests/icons/d_health.png");
const remarksOthers = require("../../../../assests/icons/d_others.png");
const remarksShopping = require("../../../../assests/icons/d_shopping.png");
const remarksTravel = require("../../../../assests/icons/d_travel.png");
const remarksInvestment = require("../../../../assests/icons/d_investment.png");

const remarksIcons = {
  FOOD: remarksfood,
  ENTERTAINMENT: remarksEntertainment,
  BILLS: remarksBill,
  TRAVEL: remarksTravel,
  HEALTH: remarksHelth,
  INVESTMENT: remarksInvestment,
  SHOPPING: remarksShopping,
  BUSINESS: remarksBusiness,
  OTHERS: remarksOthers,
};

export default function DepositStatement() {
  const navigate = useNavigate();
  const location = useLocation();
  const accList = useSelector(depositAccountListSelector);
  const [depositList, setDepositList] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [form] = Form.useForm();
  const [stage, setStage] = useState(1);
  const [type, setType] = useState("PDF");
  const profileDetails = useSelector(profileDetailsSelector);
  const [visible, setVisible] = useState(false);
  const [fileName, setFileName] = useState("");
  const [formValues, setFormValues] = useState({});
  const [reqValues, setReqValues] = useState({
    lastPstdDate: "",
    lastTxnDate: "",
    lastBalAmt: "",
    lastBalCcy: "",
    lastTxnId: "",
    lastTxnSrlNo: "",
    hasMoreData: "N",
  });
  const [selectedDetails, setSelectedDetails] = useState({});
  const [remarkVisible, setRemarkVisible] = useState(false);
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState("ACCOUNT_DETAILS");
  const [accountDetails, setAccountDetails] = useState({});
  const accountList = useSelector(depositAccountListSelector);
  const [details, settDetails] = useState(location.state);
  const [range, setRange] = useState("CURRENT");
  const [selectedAccountNo, setSelectedAccountNo] = useState(
    location.state.accountNo
  );
  const [data, setData] = useState(false);
  const [showGridAccount, setShowGridAccount] = useState("GRID");
  const dispatch = useDispatch();

  useEffect(() => {
    if (window.innerWidth < 900) {
      setShowGridAccount("LIST");
    }
  }, [window.innerWidth]);

  const sorting = [
    {
      label: t("pages.my_accounts.deposits.ascending", {
        defaultValue: "Ascending",
      }),
      value: "A",
    },
    {
      label: t("pages.my_accounts.deposits.descending", {
        defaultValue: "Descending",
      }),
      value: "D",
    },
  ];
  const PeriodTypes = [
    {
      label: t("pages.my_accounts.casa.current", {
        defaultValue: "Current",
      }),
      value: "CURRENT",
    },
    {
      label: t("pages.my_accounts.casa.three_months", {
        defaultValue: "3 Months",
      }),
      value: "3_MONTHS",
    },
    {
      label: t("pages.my_accounts.casa.six_months", {
        defaultValue: "6 Months",
      }),
      value: "6_MONTHS",
    },
    {
      label: t("pages.my_accounts.common_my_accounts.date_range", {
        defaultValue: "Date Range",
      }),
      value: "CUSTOM",
    },
  ];

  useEffect(() => {
    if (location.pathname === "/accounts/deposit/statement") {
      setActiveKey("DETAILED_STATEMENT");
    } else {
      setActiveKey("ACCOUNT_DETAILS");
    }
    if (location.state) {
      setAccountDetails(location.state);
      dispatch(setSelectedAccount(location.state));
      setDepositList(
        accList.filter((ele) => ele.accountType === location.state?.accountType)
      );
      form.setFieldsValue({
        sortIn: "A",
      });
    }
    setRange("CURRENT");
  }, []);

  const handleAccountNo = (value) => {
    setSelectedAccountNo(value);
    const accountDet = accountList.find((ele) => ele.accountNo === value);
    settDetails(accountDet);
    dispatch(setSelectedAccount(accountDet));
  };

  const handleTabClick = (key) => {
    setActiveKey(key);
    if (key === "ACCOUNT_DETAILS") {
      navigate("/accounts/deposit/summary", { state: accountDetails });
    }
  };

  const onVerify = useCallback(
    async (values) => {
      try {
        let fromDate = "";
        let toDate = "";
        const accDetails = accList.find(
          (ele) => ele.accountNo === values.accountNo
        );

        if (values.dateType === "CURRENT") {
          fromDate = moment().startOf("month").format("YYYY-MM-DD");
          toDate = moment().format("YYYY-MM-DD");
        }
        if (values.dateType === "3_MONTHS") {
          fromDate = moment().subtract(3, "month").format("YYYY-MM-DD");
          toDate = moment().format("YYYY-MM-DD");
        }
        if (values.dateType === "6_MONTHS") {
          fromDate = moment().subtract(6, "month").format("YYYY-MM-DD");
          toDate = moment().format("YYYY-MM-DD");
        }

        if (values.dateType === "CUSTOM") {
          if (values.dateRange !== undefined) {
            fromDate = values.dateRange[0].format("YYYY-MM-DD");
            toDate = values.dateRange[1].format("YYYY-MM-DD");
          }
        }

        setRange(values.dateType);

        const reqParams = {
          accountNo: details.accountNo,
          branchId: details.branchId,
          fromDate: fromDate,
          toDate: toDate,
          transactionType: "",
          sortIn: values.sortIn,
          lastPstdDate: "",
          lastTxnDate: "",
          lastBalAmt: "",
          lastBalCcy: "",
          lastTxnId: "",
          lastTxnSrlNo: "",
          hasMoreData: "N",
        };
        setFormValues({ ...reqParams, ...values, fromDate, toDate });
        const response = await AccountService.getfullacctstmtwithpagination(
          reqParams
        );
        if (response.status === 200) {
          setData(true);
          setDataSource(response.data["statement"]);
          setStage(2);
          setReqValues({
            lastPstdDate: response.data["lastPstdDate"],
            lastTxnDate: response.data["lastTxnDate"],
            lastBalAmt: response.data["lastBalAmt"],
            lastBalCcy: response.data["lastBalCcy"],
            lastTxnId: response.data["lastTxnId"],
            lastTxnSrlNo: response.data["lastTxnSrlNo"],
            hasMoreData: response.data["hasMoreData"],
          });
        }
      } catch (error) {}
    },
    [reqValues, range, details]
  );

  const fetchMoreStatements = useCallback(async () => {
    try {
      const reqParams = {
        ...formValues,
        ...reqValues,
      };

      setLoader(true);
      const response = await AccountService.getfullacctstmtwithpagination(
        reqParams
      );
      if (response.status === 200) {
        setLoader(false);
        setDataSource([
          ...dataSource,
          ...response.data["fullStmtPaginationrRecords"],
        ]);
        setReqValues({
          lastPstdDate: response.data["lastPstdDate"],
          lastTxnDate: response.data["lastTxnDate"],
          lastBalAmt: response.data["lastBalAmt"],
          lastBalCcy: response.data["lastBalCcy"],
          lastTxnId: response.data["lastTxnId"],
          lastTxnSrlNo: response.data["lastTxnSrlNo"],
          hasMoreData: response.data["hasMoreData"],
        });
      }
    } catch (error) {}
  }, [reqValues, formValues, dataSource]);

  const statementDownload = useCallback(
    async (format) => {
      try {
        let fromDate = "";
        let toDate = "";
        if (range === "CURRENT") {
          fromDate = moment().startOf("month").format("YYYY-MM-DD");
          toDate = moment();
        }

        if (range === "3_MONTHS") {
          fromDate = moment().subtract(3, "month");
          toDate = moment();
        }
        if (range === "6_MONTHS") {
          fromDate = moment().subtract(6, "month");
          toDate = moment();
        }

        if (range === "CUSTOM") {
          if (formValues.dateRange !== undefined) {
            fromDate = formValues.dateRange[0]?.format("YYYY-MM-DD");
            toDate = formValues.dateRange[1]?.format("YYYY-MM-DD");
          }
        }

        setType(format);
        const response = await AccountService.statementDownload({
          fromDate: fromDate,
          toDate: toDate,
          accountNo: formValues?.accountNo,
          branchId: formValues?.branchId,
          transactionType: "All",
          format: format,
        });

        if (response.status === 200) {
          // if (format === "PDF") {
          //   setFileName(response.data["fileName"]);
          //   setVisible(true);
          // }
          setFileName(response.data["fileName"]);
          setVisible(true);
        }
      } catch (error) {}
    },
    [formValues, range]
  );
  const handleClear = () => {
    form.setFieldsValue({
      dateType: "CURRENT",
      sortIn: "A",
    });
    setData(false);
  };
  return (
    <>
      <Breadcrumb separator=">">
        <Breadcrumb.Item>
          <span onClick={() => navigate("/dashboard")}>
            <HomeIcon height={14} />
          </span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span onClick={() => navigate("/accounts")}>
            {t("navigation.account", {
              defaultValue: "Accounts",
            })}
          </span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span>
            {t("pages.my_accounts.deposits.deposit_statement", {
              defaultValue: "Deposit Statement",
            })}
          </span>
        </Breadcrumb.Item>
      </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-left align-items-center heading mx-0">
            <h3 className="title mb-0">
              {t("pages.my_accounts.deposits.deposit_statement", {
                defaultValue: "Deposit Statement",
              })}
            </h3>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 hide-xs d-flex justify-content-end">
            <label style={{ fontSize: "18px", padding: "5px" }}>
              {t("common.account_no_lbl", {
                defaultValue: "Account Number",
              })}{" "}
              :{" "}
            </label>
            <Select
              placeholder={t("common.account_no_lbl", {
                defaultValue: "Account Number",
              })}
              bordered={true}
              optionLabelProp={"value"}
              size="large"
              value={selectedAccountNo}
              onChange={(value) => handleAccountNo(value)}
              style={{ width: "37%", textAlign: "justify" }}
            >
              {accountList.map((account, index) => (
                <Select.Option key={index} value={account.accountNo}>
                  <span className="acc-short-name">
                    {account?.acctShortName}
                  </span>
                  <br />
                  <span style={{ fontSize: "12px" }}>{account?.accountNo}</span>
                  <br />
                  <span style={{ fontSize: "12px" }}>
                    {account?.branchName}
                  </span>
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>
      </Card>

      <Card className="account-tab-card mb-1">
        <Tabs
          defaultActiveKey="1"
          type="line"
          onChange={setActiveKey}
          activeKey={activeKey}
          onTabClick={handleTabClick}
        >
          <Tabs.TabPane
            tab={t("pages.my_accounts.deposits.deposit_summary", {
              defaultValue: "Deposit Summary",
            })}
            key="ACCOUNT_DETAILS"
          ></Tabs.TabPane>

          <Tabs.TabPane
            tab={t("pages.my_accounts.deposits.deposit_statement", {
              defaultValue: "Deposit Statement",
            })}
            key="DETAILED_STATEMENT"
          ></Tabs.TabPane>
        </Tabs>
      </Card>

      <Card className="application-card">
        <div className="d-flex justify-content-between">
          <div className="d-flex">
            <div className=" account-details me-4 hide-xs">
              <label>
                {t("common.account_no_lbl", {
                  defaultValue: "Account Number",
                })}
              </label>
              <span>{details?.accountNo}</span>
            </div>{" "}
            <Form
              layout="inline"
              form={form}
              initialValues={formValues}
              onFinish={onVerify}
            >
              <Form.Item
                name="dateType"
                label=""
                className="deposit-width my-2"
                rules={[
                  {
                    required: true,
                    message: t(
                      "pages.my_accounts.deposits.date_range_req_txt",
                      {
                        defaultValue: "Date Range is required",
                      }
                    ),
                  },
                ]}
              >
                <Select
                  bordered={true}
                  size="large"
                  onSelect={(e) => setRange(e)}
                  placeholder={t(
                    "pages.my_accounts.deposits.select_date_range",
                    {
                      defaultValue: "Select Date Range",
                    }
                  )}
                >
                  {PeriodTypes.map((option, idx) => (
                    <Select.Option key={idx} value={option.value}>
                      {option.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              {range === "CUSTOM" && (
                <Form.Item label="" name="dateRange" className="my-2">
                  <DatePicker.RangePicker
                    disabledDate={(current) => {
                      return (
                        current &&
                        (current.isAfter(moment().endOf("day")) ||
                          current.isBefore(
                            moment().subtract(6, "months").startOf("day")
                          ))
                      );
                    }}
                    format={"DD-MM-YYYY"}
                    style={{ width: "100%" }}
                    size="large"
                  />
                </Form.Item>
              )}{" "}
              <Form.Item name="sortIn" label="" className="deposit-width my-2">
                <Select bordered={true} size="large">
                  {sorting.map((option, idx) => (
                    <Select.Option key={idx} value={option.value}>
                      {option.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Button
                className="btn-primary mt-2"
                size="large"
                type="default"
                htmlType="submit"
              >
                {t("pages.my_accounts.deposits.apply_filter", {
                  defaultValue: "Apply Filter",
                })}
              </Button>
            </Form>
          </div>
        </div>

        <div className="mt-2">
          {showGridAccount === "GRID" && (
            <DepositStatementGrid dataSource={dataSource} />
          )}
          {showGridAccount === "LIST" && (
            <DepositStatementList dataSource={dataSource} />
          )}

          {reqValues.hasMoreData === "Y" && (
            <div align="center">
              <Button type="default" onClick={() => fetchMoreStatements()}>
                {t("buttons.load_more_stmt_btn", {
                  defaultValue: "Load More Statements",
                })}
              </Button>
            </div>
          )}
        </div>
      </Card>

      <Modal
        title={t("common.success", {
          defaultValue: "Success",
        })}
        open={visible}
        footer={null}
        width={350}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <p style={{ fontSize: 15 }}>
          {fileName}
          {t("pages.my_accounts.casa.pdf_downloaded", {
            defaultValue: ".pdf has been downloaded.",
          })}
        </p>
        <p style={{ marginBottom: 30, fontSize: 15 }}>
          {t("pages.my_accounts.casa.open_txt", {
            defaultValue: "Your password to open the file is",
          })}{" "}
          {profileDetails?.cifId}
          {profileDetails?.registeredMobile?.slice(
            profileDetails?.registeredMobile?.length - 2
          )}{" "}
        </p>
        <div align="right" className="mt-3">
          <Button
            type="link"
            onClick={() => {
              setVisible(false);
            }}
          >
            {t("buttons.okay_btn", {
              defaultValue: "Okay",
            })}
          </Button>
        </div>
      </Modal>

      <Modal
        title={
          selectedDetails?.remarks !== null &&
          selectedDetails?.remarks?.length > 0
            ? t("pages.my_accounts.casa.edit_remarks", {
                defaultValue: "Edit Remarks",
              })
            : t("pages.my_accounts.casa.add_remarks", {
                defaultValue: "Add Remarks",
              })
        }
        closable={false}
        maskClosable={false}
        open={remarkVisible}
        footer={null}
        width={420}
        mask={true}
      >
        <SetStatementRemarks
          key={new Date().getTime()}
          setVisible={setRemarkVisible}
          selectedDetails={{
            ...selectedDetails,
            debitOrCredit: selectedDetails?.txnType,
            referenceNumber: selectedDetails?.txnId,
          }}
          accountDetails={{ acctNo: formValues?.accountNo }}
          setRefresh={(data) => {
            setRemarkVisible(false);
            onVerify(formValues);
            // dataSource.forEach((ele) => {
            //   if (ele.txnId === selectedDetails?.txnId) {
            //     ele.remarks = data.remarks;
            //     ele.remarksTag = data.remarksTag;
            //   }
            // });
            // setDataSource(dataSource);
          }}
        />
      </Modal>
    </>
  );
}
